"use client";

import { CalendarDays } from "lucide-react";
import { useRouter } from "next/navigation";
import { FormEvent, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function ForecastDatePicker({
  collection,
  initialDate,
  basePath = "/forecasts",
}: {
  collection: string;
  initialDate?: string;
  basePath?: "/" | "/forecasts";
}) {
  const router = useRouter();
  const [date, setDate] = useState(initialDate ?? "");

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (date) router.push(`${basePath}?collection=${encodeURIComponent(collection)}&date=${date}`);
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap items-end gap-2">
      <div>
        <label htmlFor="forecast-date" className="mb-1 block text-xs font-semibold text-slate-600">
          Forecast date
        </label>
        <Input
          id="forecast-date"
          type="date"
          value={date}
          onChange={(event) => setDate(event.target.value)}
          className="w-44"
        />
      </div>
      <Button type="submit" variant="outline" disabled={!date}>
        <CalendarDays className="h-4 w-4" aria-hidden />
        View
      </Button>
    </form>
  );
}
